import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sun, X } from "lucide-react";
import api from "@/lib/api";

const DISMISS_KEY = "ebenezer_sabbath_banner_dismissed";

export const SabbathBanner = () => {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const check = () => api.get("/settings/sabbath").then((r) => {
      setData(r.data);
      const stored = sessionStorage.getItem(DISMISS_KEY);
      setDismissed(stored === r.data.sabbath_start);
    }).catch(() => {});
    check();
    const t = setInterval(check, 15 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, data?.sabbath_start || "1");
    setDismissed(true);
  };

  const show = data?.active && !dismissed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sabbath-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-5 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-40"
        >
          <div className="bg-[#003B5C] text-white rounded-sm shadow-xl border-l-4 border-[#D4A437] px-5 py-4 flex items-start gap-3">
            <Sun size={20} className="text-[#D4A437] shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="font-display text-lg font-bold leading-tight" data-testid="sabbath-banner-message">{data.message}</div>
              <div className="text-xs text-white/70 mt-1">From Friday sunset to Saturday sunset · Garland, Texas</div>
            </div>
            <button onClick={dismiss} aria-label="Dismiss" data-testid="sabbath-banner-dismiss" className="p-1 text-white/60 hover:text-white rounded-sm">
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
